import { PureComponent } from "react";
import { Header, Icon, Image } from "semantic-ui-react";
import "./Home.css";

class Home extends PureComponent {
    render() {
        return <div className={"Home"}>
            <Header as='h2' icon textAlign='center'>
                <Icon name='user' circular />
                <Header.Content>Yungkei</Header.Content>
                <Header.Subheader>
                    A softwave development engineer
                </Header.Subheader>
            </Header>
            {/* <Image
                centered
                size='large'
                src='/images/wireframe/centered-paragraph.png'
            /> */}
        </div>
    }
}

export default Home;